import script from "./ISubscription.vue?vue&type=script&setup=true&lang=js"
export * from "./ISubscription.vue?vue&type=script&setup=true&lang=js"

import "./ISubscription.vue?vue&type=style&index=0&id=2838a9e8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2838a9e8"]])

export default __exports__